export default __webpack_public_path__ + "static/media/icon-menu-job.6b76e631.svg";